import { createRoot } from 'react-dom/client'
import { useState, useEffect } from 'react'

const rootElement = document.getElementById('rjo-margin-root')
const root = createRoot(rootElement)
root.render(<MarginDatabase />)

function MarginDatabase(props) {

    const serviceBase = 'https://trade.rjobrien.com/portal/weboe/api/cmssvc-v1'

    const [loading, setLoading] = useState(true)
    const [isMarkets, setIsMarkets] = useState(false);
    const [exchangeOptions, setExchangeOptions] = useState([])
    const [marketOptions, setMarketOptions] = useState([])
    const [isSpread, setIsSpread] = useState(false)

    const [contractOptions, setContractOptions] = useState()
    const [yearOptions, setYearOptions] = useState()
    const [monthOptions, setMonthOptions] = useState()

    const [exchangeMarketSelection, setExchangeMarketSelection] = useState()
    const [contractSelection, setContractSelection] = useState()
    const [yearSelection, setYearSelection] = useState()
    const [monthSelection, setMonthSelection] = useState()

    useEffect(() => {
        setLoading(true)
        clearSelections()
        fetch(`${serviceBase}/Exchanges`)
        .then(res => res.json())
        .then(data => {
            setExchangeOptions(data)
            setLoading(false)
        })
    },[])

    useEffect(() => {
        setLoading(true)
        clearSelections()
        fetch(`${serviceBase}/Markets`)
        .then(res => res.json())
        .then(data => {
            setMarketOptions(data)
            setLoading(false)
        })
    },[])
    
    useEffect(() => {
        if (!exchangeMarketSelection) return

        clearSelections('contract')

        //queryContracts
        setLoading(true)
        let url = ""
        if (isMarkets) {
            url = `${serviceBase}/ContractsByMarket/?mkt=${exchangeMarketSelection}`
        } else {  
            url = `${serviceBase}/ContractsByExchange/?exg=${exchangeMarketSelection}`
        }
        fetch(url)
        .then(res => res.json())
        .then(data => {
            setContractOptions(data)
            setLoading(false)
        })
        
    },[exchangeMarketSelection])
    
    useEffect(() => {
        if (!contractSelection) return
        clearSelections('year')

        setLoading(true)
        const contract = contractSelection
        const url = `${serviceBase}/MarginYearsForContract/?exg=${contract.exchange_code}&cont=${contract.contract_code}`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            setYearOptions(data)
            setLoading(false)
        })
        .catch(error => console.error(error))
    }, [contractSelection])
    
    useEffect(() => {
        if (!yearSelection) return
        
        clearSelections('month')
        const contract = contractSelection
        const url = `${serviceBase}/MarginMonthsForContract/?exg=${contract.exchange_code}&cont=${contract.contract_code}&year=${yearSelection}`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            setMonthOptions(data)
            setLoading(false)
        })
    },[yearSelection])
    
    function clearSelections(level = 'all') {
        switch(level) {
            case 'all':
                setExchangeMarketSelection(undefined)
            case 'contract':
                setContractSelection(undefined)
                setContractOptions(undefined)
            case 'year':
                setYearSelection(undefined)
                setYearOptions(undefined)
            case 'month':
                setMonthSelection(undefined)
                setMonthOptions(undefined)
        }
    }

    function setContractSelectionFromOption(evt) {
        // need to set the selected contract as the contract object
        const contractCode = evt.target.options[evt.target.selectedIndex].value
        const contract = contractOptions.find(e => e.contract_code === contractCode)
        setContractSelection(contract)
    }

    const typeOptions = isMarkets ? 
        marketOptions.map((item,idx) => <option key={idx}>{item}</option>)
    : 
        exchangeOptions.map((item,idx) => <option key={idx} value={item.exchange_code}>{item.exchange_short_name}</option>)

    return (<>
        <div class="margin-form">
        <span className="toggle">
            <button className={!isMarkets && "active"} onClick={() => {setIsMarkets(false); clearSelections()}}>Exchanges</button>
            <button className={isMarkets && "active"} onClick={() => {setIsMarkets(true); clearSelections()}}>Markets</button>
        </span>
        
        <select onChange={e => setExchangeMarketSelection(e.target.options[e.target.selectedIndex].value)} value={exchangeMarketSelection}>
            <option></option>
            {typeOptions}
        </select>
        {   exchangeMarketSelection && contractOptions && contractOptions.length > 0 &&
            <>
            <label for="contract">Contract</label>
            <select name="contract" value={contractSelection ? contractSelection.contract_code : undefined} onChange={setContractSelectionFromOption}>
                <option></option>
            {
                contractOptions.map((item,key) => 
                    <option key={key} value={item.contract_code}>{item.contract_name}</option>
                )
            }
            </select>
            </>
        }
        {
            contractOptions && contractOptions.length === 0 &&
            <p>No contracts found</p>
        }
        {
            contractSelection && yearOptions && yearOptions.length > 0 &&
            <>
            <label for="year">Year</label>
            <select name="year" value={yearSelection} onChange={e => setYearSelection(e.target.options[e.target.selectedIndex].value)}>
                <option></option>
            {
                yearOptions && yearOptions.map((item,key) => 
                    <option key={key} value={item.contract_year}>{item.contract_year}</option>
                )
            }
            </select>
            </>
        }
        {
            yearOptions && yearOptions.length === 0 && 
            <p>No contract years found</p>
        }
        {
            yearSelection && monthOptions && monthOptions.length > 0 &&
            <>
            <label for="month">Month</label>
            <select name="month" value={monthSelection} onChange={e => setMonthSelection(e.target.options[e.target.selectedIndex].value)}>
                <option></option>
            {
                monthOptions && monthOptions.map((item,key) => 
                    <option key={key} value={item.contract_month_num}>{item.contract_month}</option>
                )
            }
            </select>
            </>
        }
        {
            monthOptions && monthOptions.length === 0 &&
            <p>No contract months found</p>
        }
        {
            monthSelection &&
            <span className="toggle">
                <button className={!isSpread && "active"} onClick={() => setIsSpread(false)}>Outright</button>
                <button className={isSpread && "active"} onClick={() => setIsSpread(true)}>Spread</button>
            </span>
        }
        {
            monthSelection && (
                isSpread ? 
                <SpreadResults exchange={contractSelection.exchange_code} contract={contractSelection.contract_code} year={yearSelection} month={monthSelection} serviceBase={serviceBase} />
                :
                <OutrightResults exchange={contractSelection.exchange_code} contract={contractSelection.contract_code} year={yearSelection} month={monthSelection} serviceBase={serviceBase} />
            )
        }
        </div>
   </>
    )
}

function OutrightResults(props) {
    const {exchange,contract,month,year, serviceBase} = {...props}

    const [margins, setMargins] = useState()
    const [isLoading, setIsLoading] = useState()

    useEffect(() => {
        // query margins here
        setIsLoading(true)
        const url = `${serviceBase}/MarginContracts/?exg=${exchange}&cont=${contract}&year=${year}&month=${month}`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            setMargins(data)
            setIsLoading(false)
        })
    },[props])

    return <>
        {
            margins && margins.length > 0 &&
                <table>
                    <tr>
                        <td>Contract Period</td>
                        <td>Tier</td>
                        <td>Spec Init</td>
                        <td>Spec Maint</td>
                        <td>Hedge Init</td>
                        <td>Hedge Maint</td>
                        <td>Delivery Charge</td>
                        <td>Short Opt Min</td>
                    </tr>
                    {
                        margins.map(margin => (
                            <tr>
                                <td>{margin.contract_period}</td>
                                <td>{margin.contract_tier}</td>
                                <td>{margin.spec_initial}</td>
                                <td>{margin.spec_maint}</td>
                                <td>{margin.hedge_initial}</td>
                                <td>{margin.hedge_maint}</td>
                                <td>{margin.delivery_charge}</td>
                                <td>{margin.short_opt_min}</td>
                            </tr>
                        ))
                    }
                </table>
        }
        {
            margins && margins.length === 0 &&
            <p>No results found</p>
        }
        {
            isLoading &&
            <h3>Loading...</h3>
        }
    </>
}

function SpreadResults(props) {
    const {exchange,contract,month,year, serviceBase} = {...props}

    const [spreads, setSpreads] = useState()
    const [isLoading, setIsLoading] = useState()
    const [isCalendar, setIsCalendar] = useState(true)
    const [isInter, setIsInter] = useState(true)

    useEffect(() => {
        // query margins here
        setIsLoading(true)
        setSpreads(undefined)
        const url = `${serviceBase}/MarginSpreads/?exg=${exchange}&cont=${contract}&year=${year}&month=${month}&inter=${isInter ? 1 : 0 }&cal=${isCalendar ? 1 : 0 }`
        fetch(url)
        .then(res => res.json())
        .then(data => {
            setSpreads(data)
            setIsLoading(false)
        })
    },[props,isCalendar,isInter])

    return <>
        <span className="radio-group">
            <label for="both"><input type="radio" name="spreadType" id="both" checked={isCalendar && isInter} onClick={() => {setIsCalendar(true); setIsInter(true)}} />Both</label>
            <label for="calendar"><input type="radio" name="spreadType" id="calendar" checked={isCalendar && !isInter} onClick={() => {setIsCalendar(true); setIsInter(false)}} />Calendar</label>
            <label for="inter"><input type="radio" name="spreadType" id="inter" checked={!isCalendar && isInter} onClick={() => {setIsCalendar(false); setIsInter(true)}} />Inter-Commodity</label>
        </span>
        {
            spreads && spreads.length > 0 &&
            <table>
                <tr>
                    <td>Exchange</td>
                    <td>Spread Name</td>
                    <td>Spread Disc Rate</td>
                    <td>Spec Init</td>
                    <td>Spec Maint</td>
                </tr>
                {
                    spreads.map(spread => (
                        <tr>
                            <td>{spread.exchange_code}</td>
                            <td>{spread.spread_name}</td>
                            <td>{Math.floor(spread.spread_discount_rate*100)}%</td>
                            <td>{spread.spec_initial.toLocaleString('en-US', {minimumFractionDigits: 4})}</td>
                            <td>{spread.spec_maint.toLocaleString('en-US', {minimumFractionDigits: 4})}</td>
                        </tr>
                    ))
                }
            </table>
        }
        {
            spreads && spreads.length === 0 &&
            <p>No results found</p>
        }
        {
            isLoading &&
            <h3>Loading...</h3>
        }
    </>
}